import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";

export function FAQ({ qas, title = "Frequently asked questions", subtitle = "FAQ", testIdPrefix = "faq" }) {
  const [open, setOpen] = useState(0);
  return (
    <section className="py-12 lg:py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-cyan-600">{subtitle}</span>
          <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 leading-[1.05]">{title}</h2>
        </div>
        <div className="space-y-3">
          {qas.map((qa, i) => (
            <div
              key={i}
              data-testid={`${testIdPrefix}-item-${i}`}
              className={`rounded-2xl border transition-all duration-300 ${
                open === i ? "border-cyan-300 bg-cyan-50/30 shadow-md" : "border-slate-200 bg-white hover:border-slate-300"
              }`}
            >
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
              >
                <span className="font-display font-semibold text-slate-900 text-base sm:text-lg">{qa.q}</span>
                <Plus className={`w-5 h-5 text-cyan-600 flex-shrink-0 transition-transform duration-300 ${open === i ? "rotate-45" : ""}`} />
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    key="content"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.25 }}
                    className="overflow-hidden"
                  >
                    <div className="px-6 pb-5 text-slate-700 text-[15px] leading-relaxed">
                      {qa.a}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
